import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, withModifiers as _withModifiers, withKeys as _withKeys, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "member-register affiliation-info" }
const _hoisted_2 = { class: "row q-gutter-sm" }
const _hoisted_3 = { class: "col" }
const _hoisted_4 = { class: "row q-gutter-sm" }
const _hoisted_5 = { class: "col" }
const _hoisted_6 = { class: "row q-gutter-sm" }
const _hoisted_7 = { class: "col" }
const _hoisted_8 = { class: "row" }
const _hoisted_9 = {
  class: "col",
  style: {"width":"220px","flex":"none"}
}
const _hoisted_10 = { class: "row q-gutter-sm" }
const _hoisted_11 = { class: "col" }
const _hoisted_12 = { class: "row q-gutter-sm" }
const _hoisted_13 = { class: "col" }
const _hoisted_14 = { class: "row q-gutter-sm" }
const _hoisted_15 = { class: "col" }

import { computed, ref, onMounted } from 'vue';
import { Core as YubinBangoCore } from 'yubinbango-core2';
import PrefecturesSelects from '../../selects/PrefecturesSelects.vue';
import { isEmpty, isHalfKana } from '../../../common/utils/validateUtils';

interface Props {
  memberInfo: {
    work_school_name: string;
    affiliation_department_name: string;
    postal_cd: string;
    todohuken_name: string;
    street_address: string;
    phone_number: string;
  };
}


export default /*@__PURE__*/_defineComponent({
  __name: 'AfiliationInfoForm',
  props: {
    memberInfo: {}
  },
  emits: ['update:inputData'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;

// 入力値
const inputData = computed({
  get: () => props.memberInfo,
  set: (value) => {
    emit('update:inputData', value);
  },
});

// 市区町村Focus用
const streetAddressElem = ref<HTMLImageElement>();

/**
 * 住所取得
 * @param evt キーボードイベント
 */
const searchAddress = (evt: KeyboardEvent) => {
  const { postal_cd } = inputData.value;
  // 郵便番号が7桁だった場合
  if (postal_cd.length === 7) {
    // 住所情報取得
    const yubinBangoCore = new YubinBangoCore();
    yubinBangoCore.getAddr(postal_cd, (value: { [key: string]: string }) => {
      inputData.value.todohuken_name = value.region; // 都道府県
      inputData.value.street_address = value.locality; // 市区町村
      inputData.value.street_address += value.street; // 町域
      // 数値入力された場合のみ市区町村にFocus
      const keyNum = parseFloat(evt.key);
      if (!Number.isNaN(keyNum)) {
        streetAddressElem.value?.focus();
      }
    });
  }
};

/**
 * 初期表示処理
 */
// topにスクロール
onMounted(() => {
  window.scrollTo({
    top: 0,
  });
});

return (_ctx: any,_cache: any) => {
  const _component_q_input = _resolveComponent("q-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[13] || (_cache[13] = _createElementVNode("label", { class: "requier" }, "勤務先／学校名", -1)),
        _createVNode(_component_q_input, {
          ref: "workSchoolElem",
          modelValue: inputData.value.work_school_name,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputData.value.work_school_name) = $event)),
          outlined: "",
          dense: "",
          maxlength: "150",
          rules: [
            (val) => _unref(isEmpty)(val) || _ctx.$t('validation.required'),
            (val) => !_unref(isHalfKana)(val) || _ctx.$t('validation.half_kana'),
          ],
          "lazy-rules": "",
          autofocus: "",
          class: "input-area",
          hint: "例）ATTO株式会社",
          onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
        }, null, 8, ["modelValue", "rules"])
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", _hoisted_5, [
        _cache[14] || (_cache[14] = _createElementVNode("label", { class: "requier" }, "所属／学部名", -1)),
        _createVNode(_component_q_input, {
          modelValue: inputData.value.affiliation_department_name,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((inputData.value.affiliation_department_name) = $event)),
          outlined: "",
          dense: "",
          maxlength: "200",
          rules: [
            (val) => _unref(isEmpty)(val) || _ctx.$t('validation.required'),
            (val) => !_unref(isHalfKana)(val) || _ctx.$t('validation.half_kana'),
          ],
          "lazy-rules": "",
          class: "input-area",
          hint: "例）営業部",
          onKeydown: _cache[3] || (_cache[3] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
        }, null, 8, ["modelValue", "rules"])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _cache[16] || (_cache[16] = _createElementVNode("label", { class: "requier" }, "郵便番号", -1)),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_q_input, {
              modelValue: inputData.value.postal_cd,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((inputData.value.postal_cd) = $event)),
              outlined: "",
              dense: "",
              type: "tel",
              maxlength: "7",
              hint: "例）1030022（ハイフン不要）",
              rules: [(val) => _unref(isEmpty)(val) || _ctx.$t('validation.required')],
              "lazy-rules": "",
              mask: "#######",
              class: "input-area",
              onKeyup: searchAddress,
              onKeydown: _cache[5] || (_cache[5] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"])),
              onKeypress: _cache[6] || (_cache[6] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
            }, null, 8, ["modelValue", "rules"])
          ]),
          _cache[15] || (_cache[15] = _createElementVNode("div", {
            class: "col column justify-center",
            style: {"width":"calc(100% - 220px)"}
          }, [
            _createElementVNode("span", { class: "affiliation-info-form-note" }, "郵便番号入力で住所自動表示")
          ], -1))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("div", _hoisted_11, [
        _cache[17] || (_cache[17] = _createElementVNode("label", { class: "requier" }, "都道府県", -1)),
        _createVNode(PrefecturesSelects, {
          class: "q-field--with-bottom input-area",
          value: inputData.value.todohuken_name,
          onSelectValue: _cache[7] || (_cache[7] = ($event: any) => (inputData.value.todohuken_name = $event))
        }, null, 8, ["value"])
      ])
    ]),
    _createElementVNode("div", _hoisted_12, [
      _createElementVNode("div", _hoisted_13, [
        _cache[18] || (_cache[18] = _createElementVNode("label", { class: "requier" }, "市区町村以下", -1)),
        _createVNode(_component_q_input, {
          ref_key: "streetAddressElem",
          ref: streetAddressElem,
          modelValue: inputData.value.street_address,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((inputData.value.street_address) = $event)),
          outlined: "",
          dense: "",
          maxlength: "200",
          rules: [
            (val) => _unref(isEmpty)(val) || _ctx.$t('validation.required'),
            (val) => !_unref(isHalfKana)(val) || _ctx.$t('validation.half_kana'),
          ],
          "lazy-rules": "",
          class: "input-area",
          hint: "例）中央区日本橋室町4丁目5-1 さくら室町ビル5階",
          onKeydown: _cache[9] || (_cache[9] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
        }, null, 8, ["modelValue", "rules"])
      ])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createElementVNode("div", _hoisted_15, [
        _cache[19] || (_cache[19] = _createElementVNode("label", { class: "requier" }, "電話番号", -1)),
        _createVNode(_component_q_input, {
          modelValue: inputData.value.phone_number,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((inputData.value.phone_number) = $event)),
          outlined: "",
          dense: "",
          type: "tel",
          maxlength: "20",
          hint: "例）0362626467（ハイフン不要）",
          rules: [(val) => _unref(isEmpty)(val) || _ctx.$t('validation.required')],
          mask: "####################",
          class: "input-area tel-area",
          onKeydown: _cache[11] || (_cache[11] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"])),
          onKeypress: _cache[12] || (_cache[12] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
        }, null, 8, ["modelValue", "rules"])
      ])
    ])
  ]))
}
}

})